import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { persistStore, persistReducer } from "redux-persist";
import { composeWithDevTools } from "redux-devtools-extension/logOnlyInProduction";
import rootReducer from "app/rootReducer";
import errorModal from "app/middlewares/errorModal";
import crashReporter from "app/middlewares/crashReporter";
import persistConfig from "app/store/persist/persistConfig";

const middleware = [thunk, errorModal, crashReporter];

// Create store with middlewares
const store = createStore(
  persistReducer(persistConfig, rootReducer),
  /* preloadedState, */ composeWithDevTools(applyMiddleware(...middleware))
);
const persistor = persistStore(store);
export { store, persistor };
